import React from 'react';
import Navbar from '../components/Navbar';
import SecondaryHero from '../components/SecondaryHero';
import ServicesSolution from '../components/ServicesSolution';
import { ServicesOfGraphic } from '../components/Data/ServiceData';
import Servicesbuttom from '../components/Servicesbuttom';
import Footer from '../components/Footer';
import { Helmet } from "react-helmet-async"; // ✅ Added Helmet import

const MotionServic = () => {
  return (
    <>
      {/* ✅ SEO + Tab Title */}
      <Helmet>
        <title>Motion Graphics & Animations | VisionBird Technologies</title>
        <meta
          name="description"
          content="Professional 2D/3D animations, motion graphics, and explainer videos by VisionBird Technologies. We bring your ideas to life with high-quality visual effects."
        />
      </Helmet>

      <Navbar />
      <SecondaryHero
        highlight="ANIMATIONS"
        description="VisionBird Technologies is providing 2D animation, 3D animation, 
        motion graphics, explainer videos, product animations, promotional 
        animations, visual effects, character animation, video editing, and 
        animated advertisements."
        image="/assets/Images/Website designer-pana 1 (2).png"
      />
      <ServicesSolution
        title="BEST"
        highlight=" ANIMATION"
        afterthat=" SERVICES"
        description="VisionBird Technologies is a full-service animation and motion graphics company that offers a wide range of creative solutions to bring ideas to life and engage audiences effectively."
        servicesData={ServicesOfGraphic}
      />
      <Servicesbuttom
        teamImages={[
          
          "/assets/Images/zeeshan.jpg",
          "/assets/Images/saadan.jpg",
          "/assets/Images/azeeeem.jpg",
        ]}
      />
      <Footer />
    </>
  );
};

export default MotionServic;